var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 11.4142L15.2929 16.7071L16.7071 15.2929L11.4142 10L16.7071 4.70709L15.2929 3.29288L10 8.58578L4.70712 3.29288L3.29291 4.70709L8.58582 10L3.29294 15.2929L4.70715 16.7071L10 11.4142Z","fill":"white"}));
}

CloseInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
